import { customElement } from "lit/decorators.js";
import { SvgIconElement } from "../common/svg-icon-element.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let AlertsInfoWarningBoldIcon = class extends SvgIconElement {
  render() {
    return this.renderIcon({
      template: '<path d="M11.999.75c.82 0 1.575.445 1.972 1.162l9.753 18.005c.381.697.366 1.544-.038 2.227-.405.684-1.14 1.104-1.935 1.105h-19.5c-.795-.002-1.53-.423-1.935-1.108-.404-.685-.417-1.532-.034-2.229l9.747-17.995c.395-.718 1.15-1.165 1.97-1.166zm.133 16.511c-.086-.016-.175-.016-.261 0-.513.06-.923.469-.983.982-.016.087-.016.175 0 .262.062.515.468.92.983.983.043.007.086.01.13.011.569-.002 1.047-.428 1.114-.993.014-.087.014-.175 0-.262-.06-.513-.47-.923-.983-.983zm-.131-9.762c-.414 0-.75.336-.75.75v6.75c0 .414.336.75.75.75s.75-.336.75-.75v-6.75c0-.414-.336-.75-.75-.75z"/>',
      viewBox: [0, 0, 24, 24]
    });
  }
};
AlertsInfoWarningBoldIcon = __decorateClass([
  customElement("elm-alerts-info-warning-bold-icon")
], AlertsInfoWarningBoldIcon);
export { AlertsInfoWarningBoldIcon };
